module.exports = __webpack_public_path__ + "img/NCC2040_1-1.8daf2154.jpg";